/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsTriggerManualRunAodRulesMutationRequest, AuditReportsTriggerManualRunAodRulesMutationResponse, AuditReportsTriggerManualRunAodRulesPathParams, AuditReportsTriggerManualRunAodRules401, AuditReportsTriggerManualRunAodRules403 } from "../models/AuditReportsTriggerManualRunAodRules";

export function getAuditReportsTriggerManualRunAodRulesUrl(id: AuditReportsTriggerManualRunAodRulesPathParams["id"]) {
  const res = { method: 'POST', url: `/audit-reports/v1/aod-rules/${id}/manual-run` as const }
  return res
}

/**
 * @description Triggers a manual AOD run for a specific AOD rule
 * @summary Trigger a manual AOD run for an AOD rule
 * {@link /audit-reports/v1/aod-rules/:id/manual-run}
 */
export async function auditReportsTriggerManualRunAodRules(id: AuditReportsTriggerManualRunAodRulesPathParams["id"], data: AuditReportsTriggerManualRunAodRulesMutationRequest, config: Partial<RequestConfig<AuditReportsTriggerManualRunAodRulesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsTriggerManualRunAodRulesMutationResponse, ResponseErrorConfig<AuditReportsTriggerManualRunAodRules401 | AuditReportsTriggerManualRunAodRules403>, AuditReportsTriggerManualRunAodRulesMutationRequest>({ method : "POST", url : getAuditReportsTriggerManualRunAodRulesUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}